import axios from 'axios';
import axiosRetry from 'axios-retry';
import env from "react-dotenv";

const BASE_URL = env.API_URL;

const API = axios.create({
    baseURL: BASE_URL
});

const retryDelay = (retryNumber = 0) => {
    const seconds = Math.pow(2, retryNumber) * 1000;
    const randomMs = 1000 * Math.random();
    return seconds + randomMs;
};


axiosRetry(API, {
    retries: 2,
    retryDelay,
    retryCondition: axiosRetry.isRetryableError
});

export default API;
